import { render, staticRenderFns } from "./ResourcePhotoUploadModal.vue?vue&type=template&id=796e88d9&scoped=true&"
import script from "./ResourcePhotoUploadModal.vue?vue&type=script&lang=ts&"
export * from "./ResourcePhotoUploadModal.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcePhotoUploadModal.vue?vue&type=style&index=0&id=796e88d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e88d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796e88d9')) {
      api.createRecord('796e88d9', component.options)
    } else {
      api.reload('796e88d9', component.options)
    }
    module.hot.accept("./ResourcePhotoUploadModal.vue?vue&type=template&id=796e88d9&scoped=true&", function () {
      api.rerender('796e88d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/resource-details/ResourcePhotoUploadModal.vue"
export default component.exports